/**
 * Photography used on the home page.
 * Every entry is generated from the sitewide brief in docs/IMAGE-SYSTEM.md.
 */

export const heroImage: { image: string; alt: string } = {
  image:
    'https://cdn.magicpatterns.com/patterns/generated-images/c8248653-fd64-4c5d-b1b3-fa4577dfa956.jpg',
  alt: 'A designer’s desk from above in morning light: a closed laptop, a folded print proof, a pencil and a coffee cup on warm off-white paper',
}

export const principleImages: { image: string; alt: string }[] = [
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7cca06f4-1dd4-4b58-95b2-3838e4ad3454.jpg',
    alt: 'A single sheet of heavy paper folded once into a crisp diagonal crease',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f923f966-2459-47ac-bec5-3cfaec0f5f5f.jpg',
    alt: 'An even grid of small printed type specimens, read as rhythm rather than words',
  },
  {
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7a5d82b0-4071-423b-9c3c-48c39dac4e6f.jpg',
    alt: 'One confident black ink line drawn straight across a sheet of white cotton paper',
  },
]
